module.exports = __webpack_public_path__ + "static/parent-4bdec97c4841756a1729b4d0274103ee.png";